import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as t } from "./SvgIcon.js";
const c = (r) => /* @__PURE__ */ o(t, { ...r, children: /* @__PURE__ */ o("path", { d: "M16.9108 4.41083L7.5 13.8216L3.92253 10.2442L2.74414 11.4225L7.5 16.1784L18.0892 5.58921L16.9108 4.41083Z" }) });
export {
  c as Selected
};
//# sourceMappingURL=Selected.js.map
